import { createFileRoute, useParams, useSearch } from '@tanstack/react-router'
import { z } from 'zod'
import { IntakeAddressesPage } from '../../components/conversations/IntakeAddressesPage'

// Managing where mail can arrive is configuration, and configuration lives in
// pages (spec 2026-09-09-13). Non-nested (`conversations_`) because the console
// is a leaf route, not a layout: this page has its own full-width screen.
const intakeAddressesSearchSchema = z.object({
    q: z.string().optional(),
    channel: z.enum(['email', 'whatsapp', 'web']).optional(),
    scope: z.enum(['organization', 'asset']).optional(),
    // `closed=true` brings the closed addresses back. Written only when on, so
    // an absent param and "not including closed" are the same URL.
    closed: z.boolean().optional(),
    // Paging is URL state like every other filter here: the list is bounded
    // server-side (100 by default, 500 max) and a portfolio that crosses the
    // page must be able to walk past it rather than silently stop.
    limit: z.number().int().min(1).max(500).optional(),
    offset: z.number().int().min(0).optional(),
})

export const Route = createFileRoute('/$org/conversations_/intake-addresses')({
    validateSearch: intakeAddressesSearchSchema,
    component: IntakeAddresses,
})

function IntakeAddresses() {
    const { org } = useParams({ from: '/$org/conversations_/intake-addresses' })
    const search = useSearch({ from: '/$org/conversations_/intake-addresses' })

    return <IntakeAddressesPage org={org} search={search} />
}
